




import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import {ActiveInject, ActiveProvide} from "@/support/reactive"

/**
 * @status stable
 * @published 4.5.0
 * @changelog 4.5.0 Published.
 */
@Component({
    components: {}
})
export default class JdsPipelineBucket extends Vue {
}
